<template>
	<app-page>
		<app-heading title="Feature Flags" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="flags"
					:headers="headers"
					:total="count"
					:initial-state="tableState"
					:sort-by="defaultTableSort"
					:refresh.sync="refresh"
					@update="fetchFeatureFlags"
				>
					<template v-slot:deprecated="{ item }">
						<span v-if="item.deprecated">
							Yes (Will be removed on <span class="warning--text"><b>{{item.deprecation_date | date}}</b></span>)
						</span>
						<span v-else>No</span>
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('featureflag.put') && item.active"
							color="error"
							icon="fa-ban"
							table
							title="Deactivate"
							:disabled="item.deprecated"
							@click="onDeactivate([item._id])"
						>
							Deactivate
						</app-button>
						<app-button
							v-if="$ravello.can('featureflag.put') && !item.active"
							color="success"
							icon="fa-check"
							table
							title="Activate"
							@click="onActivate([item._id])"
						>
							Activate
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'api-key' }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
import { tableState } from '@/mixins'

export default {
	mixins: [tableState],
	data() {
		return {
			flags: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Key',
				value: 'key',
				sortable: true,
			}, {
				text: 'Created On',
				value: '_id',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'Active',
				value: 'active',
				sortable: true,
				cb: item => (item.active ? 'Yes' : 'No'),
			}, {
				text: 'Deprecated',
				value: 'deprecated',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			defaultTableSort: 'name',
		}
	},
	methods: {
		async fetchFeatureFlags(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('featureflags')
				.fields(['_id', 'name', 'key', 'active', 'deprecated', 'deprecation_date'])
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.flags = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				if (err.data.errors) {
					err.data.errors.forEach(error => this.$notifications.pushAlert('error', error.message))
				} else {
					this.$notifications.pushAlert('error', err.message)
				}
			}
		},
		async onUpdate(updates, successMsg) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('featureFlags')
					.update(updates)

				this.refresh = true
				this.$notifications.pushAlert('success', successMsg)
				this.$ravello.syncFeatureFlags()
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		onDeactivate(ids) {
			this.onUpdate(ids.map(id => ({
				_id: id,
				active: false,
			})), 'Feature flags successfully deactivated')
		},

		onActivate(ids) {
			this.onUpdate(ids.map(id => ({
				_id: id,
				active: true,
			})), 'Feature flags successfully activated')
		},
	},
}
</script>
